import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEvent } from '../contexts/EventContext';
import { VolunteerSettingsContent } from './EventVolunteerSettings';
import { VolunteerResponsesContent } from './EventVolunteers';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Calendar } from 'lucide-react';
import { PageHeader } from '../components/ui/page-header';

const Volunteers: React.FC = () => {
  const { t } = useTranslation();
  const { selectedEventId, selectedEvent } = useEvent();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'config';

  if (!selectedEventId) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center px-4">
        <Calendar className="h-12 w-12 text-muted-foreground mb-4" />
        <h2 className="text-xl font-semibold text-foreground mb-2">
          {t('volunteers.noEventSelected')}
        </h2>
        <p className="text-muted-foreground">
          {t('volunteers.selectEventHint')}
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-4 md:space-y-6">
      <PageHeader eyebrow={selectedEvent?.name} title={t('volunteers.title')} />

      <Tabs defaultValue={defaultTab}>
        <TabsList>
          <TabsTrigger value="config">{t('volunteers.tabs.config')}</TabsTrigger>
          <TabsTrigger value="responses">{t('volunteers.tabs.responses')}</TabsTrigger>
        </TabsList>

        <TabsContent value="config" className="mt-6">
          <VolunteerSettingsContent eventId={selectedEventId} eventSlug={selectedEvent?.slug} embedded />
        </TabsContent>

        <TabsContent value="responses" className="mt-6">
          <VolunteerResponsesContent eventId={selectedEventId} embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Volunteers;
